// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"2a21ffa8","453":"eca5f793","521":"2be094fa","677":"5055af72","730":"717d2c23","871":"1f7006f0","883":"50cf5e6b","912":"a797c293","996":"26e59377"}[chunkId] + ".chunk.js";
};